const getMetaTagsString = (elements: any) => {
    return elements.map((el: any) => {
        const props = Object.entries(el).map(([key, value]) => {
            return `${key}="${value}"`
        }).join(' ')

        return `
        <meta ${props} data-custom-tag="true">`
    }).join('')
}

export default getMetaTagsString;const getMetaTagsString = (elements: any) => {
    return elements.map((el: any) => {
        const props = Object.entries(el).map(([key, value]) => {
            return `${key}="${value}"`
        }).join(' ')

        return `
        <meta ${props} data-custom-tag="true">`
    }).join('')
}

export default getMetaTagsString;